alertify.set({
  buttonReverse: true,
  labels : {
    ok : 'Да',
    cancel : 'Нет'
  }
});

function initCommonScripts() {
  'use strict';

  $(document.body).on('overlayLoaderShow', function(e, $node) {
    $node.find('.autofocus-inp').focus();
  });
}

$(function() {
  initCommonScripts();

  $('.checkbox, .radio').each(function() {
    var self = $(this),
        inp = self.find('.checkbox-round');
    if ( inp.prop('checked') ) {
      self.addClass('checked');
    }
    inp.change(function() {
      if ( inp.prop('checked') ) {
        self.addClass('checked');
      } else {
        self.removeClass('checked');
      }
    });
  });

  $('.js-fancybox').fancybox();

  $('.js-anchor-link').click(function(e) {
    e.preventDefault();
    var target = $(this).attr('href');
    $('body').scrollTo(target, 300);
  });

  // OverlayLoader init
  $(document).on('click.overlay', '.js-overlay', function(e) {
    e.preventDefault();
    $.overlayLoader(true, $($(this).attr('href')));
  });

  $(document).on('click.overlayClose', '.popup .js-popup-close', function(e) {
    e.preventDefault();
    $.overlayLoader(false, $(this).closest('.popup'));
  });

  $('input[type="tel"], .phone-input').each(function() {
    var $_this = $(this), val;
    $_this.mask('+7 (999) 999-99-99', {autoclear: false});
  });

  var goTopBtn = $('<span class="go-top-btn"></span>');
  goTopBtn.click(function() {
    $(window).scrollTo(0, 200);
  });
  $(window).scroll(function() {
    var scrollTop = $(window).scrollTop();
    if ( scrollTop > 0 ) {
      goTopBtn.addClass('visible');
    } else {
      goTopBtn.removeClass('visible');
    }
  });
  if ( !$('.inner-page').length ) {
    $('body').append( goTopBtn );
  } else {
    $('.portfolio-section:not(.gallery-section):last').append( goTopBtn );
  }
});